import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import {
  // Tab,
  // TabList,
  // TabPanel,
  ChakraProvider,
  TabPanels,
  theme,
  Image,
  // Tabs,
  Text,
  Flex,
} from '@chakra-ui/react';
import PurchaseIcon from '../assets/img/purchase.svg';
import PurchaseColorIcon from '../assets/img/purchase_color.svg';
import GalleryIcon from '../assets/img/gallery.svg';
import GalleryColorIcon from '../assets/img/gallery_color.svg';
import CartIcon from '../assets/img/cart.svg';
import CartColorIcon from '../assets/img/cart_color.svg';
import Cart from '../components/Cart';
import Purchased from '../components/Purchased';
import AllGallery from './AllGallery';
import { useStoreState } from 'easy-peasy';

const UserTabs = props => {
  const [tabIndex0, setTabIndex0] = useState(PurchaseIcon);
  const [tabIndex1, setTabIndex1] = useState(GalleryColorIcon);
  const [tabIndex2, setTabIndex2] = useState(CartIcon);
  const [count, setCount] = useState(0);

  const eventDetails = useStoreState(state => state.eventDetails);
  const tempCart = useStoreState(state => state.tempCart);
  const isUserLogged = useStoreState(state => state.isUserLogged);
  const handleTabsChange = index => {
    switch (index) {
      case 0:
        setTabIndex0(PurchaseColorIcon);
        setTabIndex2(CartIcon);
        setTabIndex1(GalleryIcon);
        window.scrollTo(0, 0);
        break;

      case 1:
        setTabIndex1(GalleryColorIcon);
        setTabIndex0(PurchaseIcon);
        setTabIndex2(CartIcon);
        window.scrollTo(0, 0);
        break;

      case 2:
        setTabIndex2(CartColorIcon);
        setTabIndex1(GalleryIcon);
        setTabIndex0(PurchaseIcon);
        window.scrollTo(0, 0);
        break;

      default:
        setTabIndex1(GalleryColorIcon);
        setTabIndex0(PurchaseIcon);
        setTabIndex2(CartIcon);
        window.scrollTo(0, 0);
    }
  };

  const [tabIndex, setTabIndex] = useState(1);

  return (
    <ChakraProvider theme={theme}>
      {eventDetails.is_b2b_prepaid == 0 ? (
        <Tabs
          variant="unstyled"
          defaultIndex={1}
          onSelect={index => handleTabsChange(index)}
          forceRenderTabPanel={true}
        >
          <TabList
            style={{
              justifyContent: 'space-between',
              position: 'sticky',
              top: '70px',
              bg: 'white',
              paddingBottom: '4px',
              backgroundColor: 'white',
              borderBottom: '.6px solid #e9e9e9',
              zIndex: '908',
            }}
          >
            <Tab
              style={{
                paddingLeft: '10px',
                paddingRight: '0px',
                paddingBottom: '3px',
              }}
            >
              <Image
                src={tabIndex0}
                alt="User Icon"
                objectFit="cover"
                w="6"
                h="6"
                mr="2"
              />
              <Text fontSize="15px" fontWeight="400">
                Purchased
              </Text>
            </Tab>

            <Tab
              style={{
                paddingLeft: '0px',
                paddingRight: '4px',
                paddingBottom: '3px',
              }}
            >
              <Image
                src={tabIndex1}
                alt="User Icon"
                objectFit="cover"
                w="6"
                h="6"
                mr="2"
              />
              <Text fontSize="15px" fontWeight="400">
                All
              </Text>
            </Tab>

            <Tab
              style={{
                paddingLeft: '0px',
                paddingRight: '10px',
                paddingBottom: '3px',
              }}
            >
              {tempCart.length ? (
                <Flex
                  mt="-7"
                  alignItems="center"
                  justifyContent="center"
                  ml="4"
                  w="18px"
                  h="18px"
                  bg="#FA2F45"
                  borderRadius="40"
                  top="30px"
                  zIndex="912"
                  position="absolute"
                >
                  <Text color="white" fontSize="11px" pt="1px" fontWeight="700">
                    <span style={{ color: 'white' }}> {tempCart.length}</span>
                  </Text>
                </Flex>
              ) : null}
              <Image
                src={tabIndex2}
                alt="User Icon"
                objectFit="cover"
                w="6"
                h="6"
                mr="2"
              />
              <Text fontSize="15px" fontWeight="400">
                Cart
              </Text>
            </Tab>
          </TabList>

          <TabPanel>
            <Purchased {...props} />
          </TabPanel>
          <TabPanel>
            <AllGallery {...props} />
          </TabPanel>
          <TabPanel>
            <Cart {...props} setCount={setCount} CartItemCount={count} />
          </TabPanel>
        </Tabs>
      ) : isUserLogged ? (
        <AllGallery {...props} />
      ) : (
        <AllGallery {...props} />
      )}
    </ChakraProvider>
    //   <ChakraProvider theme={theme}>
    //     <Tabs variant="unstyled" defaultIndex={1} onChange={handleTabsChange}>
    //       <TabList
    //         justifyContent="space-between"
    //         position="sticky"
    //         top="70px"
    //         bg="white"
    //         borderBottom=".6px solid #e9e9e9"
    //         zIndex="909"
    //       >
    //         <Tab
    //           _selected={{ color: '#FA2F45' }}
    //           _focus={{ boxShadow: 'none' }}
    //           pl="3"
    //           pr="0"
    //           pb="3"
    //         >
    //           <Image
    //             src={tabIndex0}
    //             alt="User Icon"
    //             objectFit="cover"
    //             w="6"
    //             h="6"
    //             mr="2"
    //           />
    //           <Text fontSize="15px" fontWeight="400">
    //             Purchased
    //           </Text>
    //         </Tab>

    //         <Tab
    //           _selected={{ color: '#FA2F45' }}
    //           _focus={{ boxShadow: 'none' }}
    //           pl="0"
    //           pr="4"
    //           pb="3"
    //         >
    //           <Image
    //             src={tabIndex1}
    //             alt="User Icon"
    //             objectFit="cover"
    //             w="6"
    //             h="6"
    //             mr="2"
    //           />
    //           <Text fontSize="15px" fontWeight="400">
    //             All
    //           </Text>
    //         </Tab>

    //         <Tab
    //           _selected={{ color: '#FA2F45' }}
    //           _focus={{ boxShadow: 'none' }}
    //           pl="0"
    //           pr="5"
    //           pb="3"
    //         >
    //           {count ? (
    //             <Flex
    //               mt="-7"
    //               alignItems="center"
    //               justifyContent="center"
    //               ml="-3"
    //               w="18px"
    //               h="18px"
    //               bg="#FA2F45"
    //               borderRadius="40"
    //               top="30px"
    //               position="absolute"
    //             >
    //               <Text color="white" fontSize="11px" pt="1px" fontWeight="700">
    //                 {tempCart?.length}
    //               </Text>
    //             </Flex>
    //           ) : null}
    //           <Image
    //             src={tabIndex2}
    //             alt="User Icon"
    //             objectFit="cover"
    //             w="6"
    //             h="6"
    //             mr="2"
    //           />
    //           <Text fontSize="15px" fontWeight="400">
    //             Cart
    //           </Text>
    //         </Tab>
    //       </TabList>

    //       <TabPanels>
    //         <TabPanel p="0px">
    //           <Purchased {...props} />
    //         </TabPanel>

    //         <TabPanel p="0px">
    //           <AllGallery {...props} CartItemCount={count} />
    //         </TabPanel>

    //         <TabPanel p="0px">
    //           <Cart {...props} setCount={setCount} CartItemCount={count} />
    //         </TabPanel>
    //       </TabPanels>
    //     </Tabs>
    //   </ChakraProvider>
  );
};
export default UserTabs;
